import { IApplicationState, TCardId } from '../../../../types/types';
import { getCard } from 'app/store/model/selectors/getCard';

export const getUserChatId = (
    state: IApplicationState,
    cardId: TCardId,
) => {
   const card = getCard(state, cardId)
   return card?.chatId;
}
